import { faBoxes } from '@fortawesome/pro-regular-svg-icons'
import { type ComponentProps, type ComponentType } from 'react'

import { type UNSAFE_any, type CoreProduct } from '@flecto/types'

import { Badge, type BadgeProps } from '../Badge/Badge'
import { Icon } from '../Icon/Icon'
import { PopoverProductBundleItems } from '../PopoverProductBundleItems/PopoverProductBundleItems'
import classes from './styles.module.css'

export type BadgeProductBundlePopoverDefault = typeof PopoverProductBundleItems

export type BadgeProductBundlePopoverOverrideProps<
  C extends ComponentType<UNSAFE_any> = typeof PopoverProductBundleItems,
> = {
  popoverComponent?: C
  popoverProps?: ComponentProps<C>
}

export type BadgeProductBundleProps<
  C extends ComponentType<UNSAFE_any> = typeof PopoverProductBundleItems,
> = BadgeProps &
  BadgeProductBundlePopoverOverrideProps<C> & {
    product?: CoreProduct
  }

export function BadgeProductBundle<
  C extends ComponentType<UNSAFE_any> = BadgeProductBundlePopoverDefault
>({
  product,
  size = 'sm',
  popoverComponent = PopoverProductBundleItems as C,
  popoverProps,
  ...props
}: BadgeProductBundleProps<C>) {
  if (!product?.bundle) {
    return <></>
  }

  const PopoverComponent = popoverComponent
  const popProps = popoverProps || { product }

  return (
    // @ts-expect-error PopoverProductBundleItems without types
    <PopoverComponent data-testid='popover' {...popProps}>
      <Badge
        data-testid='badge'
        size={size}
        color='gray'
        className={classes.badge}
        {...props}
        leftSection={<Icon icon={faBoxes} />}
      />
    </PopoverComponent>
  )
}
